declare const jQuery: any;
const $ = jQuery;
type JQuery = any;

const wheelThreshold = 50;

export interface WheelEvent
{
	direction: "up"|"down";
	$el: JQuery;
}

export type WheelEventHandler = (ev: WheelEvent) => any;

export interface WheelEventControls
{
	on: () => void;
	off: () => void;
}

/**
 * When $el is scrolled a certain distance, the handler func will be called.
 * It's sort of like a non-touch version of a hammer vertical swipe.
 * @param {JQuery|HTMLElement|string}            $el     The element to listen on
 * @param {WheelEventHandler} handler The event handler to call on wheel event
 */
export function onVerticalWheel($el: JQuery|HTMLElement|string, handler: WheelEventHandler): WheelEventControls
{
	$el = $($el);
	let deltaTotal = 0;
	let direction: "up"|"down"|undefined = undefined;
	let timer: any = undefined;
	let handlerFired = false;
	let active = false;

	const reset = () => {
		deltaTotal = 0;
		handlerFired = false;
		direction = undefined;
	};

	const handleEvent = e => {
		e.preventDefault();
		e.stopPropagation();
		if (handlerFired)
		{
			return;
		}
		clearTimeout(timer);
		timer = setTimeout(reset, 500);
		const dy: number = e.originalEvent.deltaY;
		const oldDirection = direction;
		direction = (dy < 0) ? "down" : "up";
		if (direction !== oldDirection)
		{
			deltaTotal = dy;
		}
		else
		{
			deltaTotal += Math.abs(dy);
		}
		if (deltaTotal >= wheelThreshold)
		{
			handler({ direction, $el });
			handlerFired = true;
		}
	};

	const on = () => {
		if (!active)
		{
			$el.on("wheel", handleEvent);
			active = true;
		}
	};

	const off = () => {
		if (active)
		{
			$el.off("wheel", handleEvent);
			active = false;
		}
	};

	on();

	return { on, off };
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].wheel = {
	onVerticalWheel
};
